module.exports = __webpack_public_path__ + "static/media/inf_31pog32p.b6c41f47.mp3";